import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    if (document.body.getAttribute("data-action") == "edit" || document.body.getAttribute("data-action") == "update") {
      if (event.currentTarget.defaultValue == 1) {
        document.getElementById("colletionPointAddressBlock").classList.remove("is-display-none")
      } else {
        document.getElementById("colletionPointAddressBlock").classList.add("is-display-none")
      }
    }

    if (document.body.getAttribute("data-action").includes("new") || document.body.getAttribute("data-action").includes("create") || document.body.getAttribute("data-action").includes("edit") || document.body.getAttribute("data-action").includes("update")) {
      var cleave = new Cleave(".input-date", {
        date: true,
        datePattern: ["d", "m", "Y"]
      })
    }
  }

  // Change residue type and return collection units
  changeCollectionPoint(event) {
    if (event.currentTarget.defaultValue == 1) {
      document.getElementById("colletionPointAddressBlock").classList.remove("is-display-none")
    } else {
      document.getElementById("colletionPointAddressBlock").classList.add("is-display-none")
    }
  }
}
